import { createFileRoute } from '@tanstack/react-router';
import { JourneysWarehouseHandoff } from '@/pages/workspaces/integrations/warehouse/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/integrations/warehouse/bigquery` URL — what the Ember directory links to.
 * Flag off it renders the embedded Ember host; flag on it forwards to the migrated URL.
 *
 * The resolver is required, not decorative: ownership claims the `/workspaces/last` form of this
 * URL, so the embedded app — which would otherwise resolve the sentinel itself — never mounts to do
 * it, and the handoff has no workspace id to forward to. `appBundle` belongs here and not on the
 * migrated twin: this URL keeps the `journeys` segment, so the bundle-aware branch can rebuild the
 * target from the bundle prefix.
 */
function JourneysWarehouseBigQueryRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysWarehouseHandoff connector="bigquery" />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/bigquery',
)({
  component: JourneysWarehouseBigQueryRoute,
});
